import { openLinkedFeedback } from '@/common/telemetry/sentry.ts';
import { Alert, Button, Group, Stack, Text } from '@mantine/core';

type AppErrorFallbackProps = {
  title?: string;
  message?: string;
  eventId?: string;
  onRetry?: () => void;
  onReload?: () => void;
  onBack?: () => void;
  withReport?: boolean;
};

export default function AppErrorFallback({
  title = 'Something went wrong',
  message = 'Please try again. If the issue persists, report it for support.',
  eventId,
  onRetry,
  onReload,
  onBack,
  withReport = true,
}: AppErrorFallbackProps) {
  return (
    <Alert title={title} color="red">
      <Stack gap="sm">
        <Text size="sm">{message}</Text>
        {eventId ? (
          <Text size="xs" c="dimmed">
            Event ID: {eventId}
          </Text>
        ) : null}
        <Group gap="xs">
          {onRetry ? (
            <Button size="compact-sm" variant="light" onClick={onRetry}>
              Retry
            </Button>
          ) : null}
          {onReload ? (
            <Button size="compact-sm" variant="default" onClick={onReload}>
              Reload
            </Button>
          ) : null}
          {onBack ? (
            <Button size="compact-sm" variant="default" onClick={onBack}>
              Back
            </Button>
          ) : null}
          {withReport ? (
            <Button
              size="compact-sm"
              variant="outline"
              onClick={() => openLinkedFeedback({ eventId })}
            >
              Report issue
            </Button>
          ) : null}
        </Group>
      </Stack>
    </Alert>
  );
}
